// src/PreAssessmentQuiz.js
import React, { useState } from 'react';
import { quizQuestions } from '../data/quizData';
import './PreAssessmentQuiz.css';

function PreAssessmentQuiz({ coursePackages, onQuizComplete, onShowRecommendation }) {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [scores, setScores] = useState({});
    const [showResults, setShowResults] = useState(false);
    const [recommendedPackage, setRecommendedPackage] = useState(null);

    const handleAnswerOptionClick = (packageScores) => {
        const updatedScores = { ...scores };
        for (const packageId in packageScores) {
            updatedScores[packageId] = (updatedScores[packageId] || 0) + packageScores[packageId];
        }
        setScores(updatedScores);

        const nextQuestion = currentQuestionIndex + 1;
        if (nextQuestion < quizQuestions.length) {
            setCurrentQuestionIndex(nextQuestion);
        } else {
            calculateResults(updatedScores);
            setShowResults(true);
        }
    };

    const calculateResults = (finalScores) => {
        let maxScore = -1;
        let recommendedId = null;

        // Find the package ID with the highest score
        for (const packageId in finalScores) {
            if (finalScores[packageId] > maxScore) {
                maxScore = finalScores[packageId];
                recommendedId = parseInt(packageId);
            }
        }
        
        // Handle cases where no answers strongly point to a single package (e.g. recommend default or first)
        if (!recommendedId && coursePackages.length > 0) {
            recommendedId = coursePackages[0].id; 
        }


        const recommended = coursePackages.find(pkg => pkg.id === recommendedId);
        setRecommendedPackage(recommended);
        if (recommended) {
            onQuizComplete(recommended.id);
        } else if (coursePackages.length > 0) { // Fallback if no specific recommendation
             onQuizComplete(coursePackages[0].id); // Recommend the first course by default
             setRecommendedPackage(coursePackages[0]);
        }
    };

    const resetQuiz = () => {
        setCurrentQuestionIndex(0);
        setScores({});
        setShowResults(false);
        setRecommendedPackage(null);
        onQuizComplete(null); // Clear previous recommendation
    };

    if (showResults) {
        return (
            <div className="quiz-results">
                <h3>Quiz Complete!</h3>
                {recommendedPackage ? (
                    <>
                        <p>Based on your answers, we recommend exploring:</p>
                        <h4>{recommendedPackage.name}</h4>
                        <button
                            onClick={() => onShowRecommendation(recommendedPackage.id)}
                            className="quiz-view-recommendation-button"
                        >
                            View Recommended Course
                        </button>
                    </>
                ) : (
                    <p>Thanks for taking the quiz! Explore our courses to find a great fit.</p>
                )}
                <button onClick={resetQuiz} className="quiz-retake-button">Retake Quiz</button>
            </div>
        );
    }

    if (!quizQuestions || quizQuestions.length === 0) {
        return <p>Quiz is currently unavailable.</p>;
    }
    
    const currentQuestion = quizQuestions[currentQuestionIndex];

    return (
        <div className="quiz-container">
            <h3>{currentQuestion.questionText}</h3>
            <div className="quiz-options">
                {currentQuestion.options.map((option, index) => (
                    <button
                        key={index}
                        onClick={() => handleAnswerOptionClick(option.packageScores)}
                        className="quiz-option-button"
                    >
                        {option.text}
                    </button>
                ))}
            </div>
            <div className="quiz-progress">
                Question {currentQuestionIndex + 1} of {quizQuestions.length}
            </div>
        </div>
    );
}

export default PreAssessmentQuiz;